import { IdentifyProgressBar } from '../../../../../components';
import { CaptureBackLogic } from '../_containers';

export default function CaptureBackPage() {
  return (
    <div className='flex h-dvh w-full flex-col items-center'>
      <IdentifyProgressBar currentStep={1} />
      <CaptureBackLogic />
    </div>
  );
}
